//
// Aggregator.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./DataValue";

var Aggregator = createModule("commons::Aggregator", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getMissingCount: [6],
        getStringValue: [7],
        _aggregate_o: [0,1],
        getMin: [6],
        _aggregate_snnn: [0,7,4,3,3],
        getNumericValue: [6,4,6],
        getFirst: [1],
        getMax: [6],
        _aggregate_nnn: [0,6,3,3],
        getCount: [6],
        getSum: [6],
    },
    {
        _create: [4,2],
    },
    ["aggregate"],
]);
export default Aggregator;
